/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      component — «UI nuova» fork of ListFilters (M18 ec-catalog):
 *              the active filters of the list as removable chips
 *   extends:   ListFiltersComponent
 *   template:  filter-chips.hbs
 *   args:      @setReload, @applicationController, @filterStatusName
 *   uses:      -
 *   siblings:  components/list-filters.js (the classic it extends: setReload
 *              strips the DOM Event `{{on}}` appends before forwarding)
 *   tests:     ui-nuova-ec-catalog-test.js
 *
 * Rendered by ec-catalog-nuova/list-page.hbs.
 */
import ListFiltersComponent from '../list-filters';

export default class EcCatalogNuovaFilterChipsComponent extends ListFiltersComponent {}
